export const capitalize = (str: string) => {
  !str && (str = "");
  return str
    .split(" ")
    .map((i) => i.charAt(0).toUpperCase() + i.slice(1).toLowerCase())
    .join(" ");
};
